// Maps a browser language tag to the locale codes we may offer, best first.
// Other Spanish regions (es-AR, es-ES...) are offered Mexico first, then
// Colombia, so the visitor always sees which regional version is suggested.
// English browsers are offered the global English version, except on the US
// (root) pages, where they are already home: listing en-US first makes that
// match the current page, so nothing is suggested.
function candidatesFor(tag = '', currentLocale) {
  const t = tag.toLowerCase();

  if (t.startsWith('pt')) return ['pt-BR', 'pt'];
  if (t === 'es-mx') return ['es-MX', 'es'];
  if (t === 'es-co') return ['es-CO', 'es'];
  if (t.startsWith('es')) return ['es-MX', 'es-CO', 'es'];
  if (t.startsWith('en')) {
    return currentLocale === 'en-US' ? ['en-US'] : ['en-LATAM', 'en'];
  }

  return [];
}

// Returns the locale to suggest for a page, or null when nothing should be
// suggested. `availableLocales` are the locales the current page exists in.
export function getSuggestedLocale(availableLocales, currentLocale) {
  if (typeof navigator === 'undefined') return null;

  const browserLangs = navigator.languages?.length
    ? navigator.languages
    : [navigator.language];

  for (const tag of browserLangs) {
    const match = candidatesFor(tag, currentLocale).find((c) =>
      availableLocales.includes(c)
    );
    if (match) return match === currentLocale ? null : match;
  }

  return null;
}
